import clsx from 'clsx'
import type { FC } from 'react'

type LogoProps = {
  className?: string
  height?: string
}

export const FynbosLogo: FC<LogoProps> = ({ className, height }) => {
  return (
    <svg
      className={clsx('flex-none', height ? height : 'h-12', className)}
      viewBox='0 0 1432 400'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        className='fill-current'
        d='M116.246 130.171H78.9086V299.151H24.25V130.171H0V85.9051H24.25V75.1273C24.25 48.9528 31.6918 29.7068 46.5753 17.3893C61.4589 5.07188 83.9126 -0.701918 113.936 0.067928V45.4885C100.849 45.2319 91.7393 47.4131 86.607 52.0321C81.4748 56.6512 78.9086 64.9911 78.9086 77.0519V85.9051H116.246V130.171Z'
      />
      <path
        className='fill-current'
        d='M366.724 85.9051L234.696 400H177.343L223.533 293.762L138.081 85.9051H198.514L253.557 234.869L309.371 85.9051H366.724Z'
      />
      <path
        className='fill-current'
        d='M510.094 82.8258C535.499 82.8258 556.028 90.9091 571.682 107.076C587.335 122.986 595.162 145.311 595.162 174.052V299.151H541.273V181.365C541.273 164.429 537.039 151.47 528.571 142.488C520.102 133.25 508.555 128.631 493.928 128.631C479.044 128.631 467.24 133.25 458.515 142.488C450.047 151.47 445.813 164.429 445.813 181.365V299.151H391.924V85.9051H445.813V112.465C452.998 103.227 462.108 96.0413 473.142 90.9091C484.433 85.5202 496.75 82.8258 510.094 82.8258Z'
      />
      <path
        className='fill-current'
        d='M696.447 117.084C703.375 106.819 712.87 98.4792 724.931 92.0638C737.248 85.6485 751.234 82.4408 766.887 82.4408C785.107 82.4408 801.53 86.9316 816.157 95.913C831.041 104.895 842.717 117.725 851.185 134.405C859.91 150.828 864.272 169.946 864.272 191.758C864.272 213.57 859.91 232.945 851.185 249.881C842.717 266.561 831.041 279.52 816.157 288.758C801.53 297.996 785.107 302.615 766.887 302.615C750.977 302.615 736.992 299.536 724.931 293.377C713.127 286.962 703.632 278.75 696.447 268.742V299.151H642.558V14.31H696.447V117.084ZM809.229 191.758C809.229 178.927 806.534 167.893 801.145 158.655C796.013 149.16 789.084 141.975 780.359 137.1C771.891 132.224 762.653 129.786 752.645 129.786C742.894 129.786 733.656 132.352 724.931 137.484C716.463 142.36 709.534 149.545 704.145 159.04C699.013 168.535 696.447 179.697 696.447 192.528C696.447 205.359 699.013 216.521 704.145 226.016C709.534 235.511 716.463 242.824 724.931 247.957C733.656 252.832 742.894 255.27 752.645 255.27C762.653 255.27 771.891 252.704 780.359 247.572C789.084 242.439 796.013 235.126 801.145 225.631C806.534 216.136 809.229 204.845 809.229 191.758Z'
      />
      <path
        className='fill-current'
        d='M994.273 302.615C973.744 302.615 955.268 298.124 938.844 289.143C922.421 279.905 909.462 266.946 899.967 250.266C890.729 233.586 886.11 214.34 886.11 192.528C886.11 170.716 890.858 151.47 900.352 134.79C910.104 118.11 923.319 105.279 939.999 96.298C956.679 87.0599 975.283 82.4408 995.812 82.4408C1016.34 82.4408 1034.95 87.0599 1051.63 96.298C1068.31 105.279 1081.39 118.11 1090.89 134.79C1100.64 151.47 1105.51 170.716 1105.51 192.528C1105.51 214.34 1100.51 233.586 1090.5 250.266C1080.75 266.946 1067.41 279.905 1050.47 289.143C1033.79 298.124 1015.06 302.615 994.273 302.615ZM994.273 255.655C1004.02 255.655 1013.13 253.345 1021.6 248.726C1030.33 243.851 1037.26 236.666 1042.39 227.171C1047.52 217.676 1050.09 206.129 1050.09 192.528C1050.09 172.256 1044.7 156.73 1033.92 145.953C1023.4 134.918 1010.44 129.401 995.043 129.401C979.646 129.401 966.687 134.918 956.166 145.953C945.901 156.73 940.769 172.256 940.769 192.528C940.769 212.8 945.773 228.454 955.781 239.488C966.045 250.266 978.876 255.655 994.273 255.655Z'
      />
      <path
        className='fill-current'
        d='M1222.8 302.615C1205.35 302.615 1189.69 299.536 1175.84 293.377C1161.98 286.962 1150.95 278.365 1142.73 267.587C1134.78 256.81 1130.42 244.877 1129.65 231.79H1183.92C1184.95 240.001 1188.93 246.802 1195.85 252.191C1203.04 257.579 1211.89 260.274 1222.41 260.274C1232.68 260.274 1240.63 258.221 1246.28 254.115C1252.18 250.009 1255.13 244.749 1255.13 238.333C1255.13 231.405 1251.54 226.273 1244.35 222.937C1237.43 219.344 1226.26 215.495 1210.87 211.389C1194.96 207.54 1181.87 203.562 1171.6 199.457C1161.6 195.351 1152.87 189.064 1145.43 180.595C1138.24 172.127 1134.65 160.708 1134.65 146.338C1134.65 134.533 1137.99 123.756 1144.66 114.004C1151.59 104.253 1161.34 96.5546 1173.91 90.9091C1186.74 85.2636 1201.76 82.4408 1218.95 82.4408C1244.35 82.4408 1264.63 88.8562 1279.77 101.687C1294.91 114.261 1303.25 131.326 1304.79 152.881H1253.21C1252.44 144.413 1248.84 137.741 1242.43 132.865C1236.27 127.733 1227.93 125.167 1217.41 125.167C1207.66 125.167 1200.09 126.963 1194.7 130.556C1189.57 134.148 1187 139.152 1187 145.568C1187 152.753 1190.59 158.27 1197.78 162.119C1204.96 165.712 1216.13 169.433 1231.27 173.282C1246.66 177.131 1259.37 181.109 1269.37 185.215C1279.38 189.32 1287.98 195.736 1295.16 204.461C1302.6 212.929 1306.45 224.22 1306.71 238.333C1306.71 250.651 1303.25 261.685 1296.32 271.437C1289.65 281.188 1279.89 288.886 1267.06 294.532C1254.49 299.921 1239.73 302.615 1222.8 302.615Z'
      />
      <path
        d='M1387.77 302.743C1374.77 302.743 1363.99 298.809 1355.43 290.939C1347.22 282.728 1343.12 272.634 1343.12 260.659C1343.12 248.684 1347.22 238.761 1355.43 230.892C1363.99 222.68 1374.77 218.574 1387.77 218.574C1400.43 218.574 1410.86 222.68 1419.07 230.892C1427.29 238.761 1431.39 248.684 1431.39 260.659C1431.39 272.634 1427.29 282.728 1419.07 290.939C1410.86 298.809 1400.43 302.743 1387.77 302.743Z'
        fill='#F43F5E'
      />
    </svg>
  )
}

export const FynbosIcon: FC<LogoProps> = ({ className, height }) => {
  return (
    <svg
      viewBox='0 0 24 24'
      className={clsx('flex-none', height ? height : 'h-6', className)}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3 3V3C7.97056 3 12 7.02944 12 12V12L3 12L3 3Z'
        className={clsx(className ? 'fill-current' : 'fill-[#FEF08A]')}
      />
      <path
        d='M12 7.5C12 5.01472 14.0147 3 16.5 3V3C18.9853 3 21 5.01472 21 7.5V7.5C21 9.98528 18.9853 12 16.5 12V12C14.0147 12 12 9.98528 12 7.5V7.5Z'
        className={clsx(className ? 'fill-current' : 'fill-[#F43F5E]')}
      />
      <path
        d='M3 12L12 12L12 21V21C7.02944 21 3 16.9706 3 12V12Z'
        className={clsx(className ? 'fill-current' : 'fill-[#84CC16]')}
      />
      <path
        d='M12 12L21 12V12C21 16.9706 16.9706 21 12 21V21L12 12Z'
        className={clsx(className ? 'fill-current' : 'fill-[#BEF264]')}
      />
    </svg>
  )
}

export const GithubIcon: FC<LogoProps> = ({ className, height }) => {
  return (
    <svg
      viewBox='0 0 24 24'
      className={clsx(
        'h-6 flex-none',
        height ? height : 'h-6',
        className ?? 'text-black'
      )}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_3172_2417)'>
        <path
          d='M12 3.81396C7.0305 3.81396 3 7.84371 3 12.814C3 16.7905 5.5785 20.164 9.15525 21.3542C9.6045 21.4375 9.75 21.1585 9.75 20.9215V19.246C7.2465 19.7905 6.72525 18.184 6.72525 18.184C6.31575 17.1437 5.7255 16.867 5.7255 16.867C4.90875 16.3082 5.78775 16.3202 5.78775 16.3202C6.6915 16.3832 7.167 17.248 7.167 17.248C7.9695 18.6235 9.27225 18.226 9.786 17.9957C9.86625 17.4145 10.0995 17.017 10.3575 16.7927C8.35875 16.564 6.25725 15.7922 6.25725 12.3445C6.25725 11.3612 6.609 10.5587 7.18425 9.92871C7.09125 9.70146 6.783 8.78572 7.272 7.54672C7.272 7.54672 8.028 7.30521 9.74775 8.46921C10.4655 8.26971 11.235 8.16996 12 8.16621C12.765 8.16996 13.5352 8.26971 14.2545 8.46921C15.9727 7.30521 16.7272 7.54672 16.7272 7.54672C17.217 8.78647 16.9087 9.70221 16.8158 9.92871C17.3932 10.5587 17.742 11.362 17.742 12.3445C17.742 15.8012 15.6368 16.5625 13.6327 16.7852C13.9552 17.0642 14.25 17.6117 14.25 18.4517V20.9215C14.25 21.1607 14.394 21.442 14.8507 21.3535C18.4245 20.1617 21 16.789 21 12.814C21 7.84371 16.9703 3.81396 12 3.81396Z'
          className='fill-current'
        />
      </g>
      <defs>
        <clipPath id='clip0_3172_2417'>
          <rect
            width='18'
            height='18'
            fill='white'
            transform='translate(3 3.81396)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const InstagramIcon: FC<LogoProps> = ({ className, height }) => {
  return (
    <svg
      viewBox='0 0 24 24'
      className={clsx('flex-none', height ? height : 'h-6', className)}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20.9458 9.10336C20.902 8.14537 20.7498 7.49116 20.5274 6.91876C20.3014 6.31816 19.9472 5.77416 19.4894 5.32456C19.04 4.86676 18.4958 4.51216 17.8952 4.28616C17.3228 4.06396 16.6686 3.91196 15.7106 3.86836C14.7508 3.82456 14.4442 3.81396 12 3.81396C9.5558 3.81396 9.2492 3.82456 8.2894 3.86816C7.3314 3.91196 6.6772 4.06416 6.1048 4.28656C5.5042 4.51256 4.9602 4.86676 4.5106 5.32456C4.0528 5.77396 3.6982 6.31796 3.4722 6.91856C3.25 7.49116 3.098 8.14536 3.0544 9.10316C3.0104 10.0632 3 10.3698 3 12.814C3 15.2584 3.0104 15.565 3.0544 16.5248C3.098 17.4826 3.2502 18.137 3.4728 18.7094C3.6988 19.3098 4.053 19.854 4.5108 20.3034C4.9602 20.7612 5.5044 21.1156 6.105 21.3414C6.6774 21.564 7.3316 21.716 8.2896 21.7598C9.2494 21.8036 9.556 21.814 12.0002 21.814C14.4444 21.814 14.751 21.8038 15.7108 21.7598C16.6688 21.716 17.323 21.564 17.8954 21.3414C19.1044 20.874 20.06 19.9182 20.5274 18.7094C20.75 18.1368 20.902 17.4826 20.9458 16.5248C20.9896 15.5648 21 15.2582 21 12.814C21 10.3698 20.9896 10.0632 20.9458 9.10336ZM19.3258 16.451C19.2858 17.3286 19.1392 17.805 19.016 18.1222C18.7132 18.9072 18.0928 19.5274 17.308 19.8302C16.991 19.9534 16.5144 20.1 15.6368 20.14C14.688 20.1834 14.4032 20.1924 12 20.1924C9.5966 20.1924 9.312 20.1834 8.3632 20.14C7.4858 20.1 7.0092 19.9534 6.692 19.8302C6.3012 19.6858 5.9476 19.4558 5.6572 19.1568C5.3582 18.8664 5.1282 18.513 4.9838 18.122C4.8606 17.805 4.714 17.3284 4.674 16.4508C4.6308 15.5018 4.6216 15.2172 4.6216 12.814C4.6216 10.4108 4.6308 10.1262 4.674 9.17717C4.7142 8.29956 4.8606 7.82316 4.9838 7.50596C5.1282 7.11496 5.3582 6.76136 5.6572 6.47096C5.9476 6.17196 6.3012 5.94196 6.6922 5.79776C7.0092 5.67436 7.4858 5.52796 8.3634 5.48776C9.3122 5.44476 9.5968 5.43556 12 5.43556C14.4032 5.43556 14.6876 5.44476 15.6366 5.48816C16.5142 5.52816 16.9906 5.67476 17.3078 5.79796C17.6986 5.94236 18.0522 6.17236 18.3426 6.47116C18.6416 6.76156 18.8716 7.11516 19.0158 7.50617C19.1392 7.82316 19.2858 8.29976 19.3258 9.17736C19.369 10.1264 19.3782 10.411 19.3782 12.8142C19.3782 15.2174 19.3692 15.5018 19.3258 16.451Z'
        className={clsx(
          className ? 'fill-current' : 'fill-[url(#paint0_linear_2623_2308)]'
        )}
      />
      <path
        d='M11.9998 8.19238C9.44737 8.19238 7.37817 10.2616 7.37817 12.814C7.37817 15.3664 9.44737 17.4356 11.9998 17.4356C14.5524 17.4356 16.6214 15.3664 16.6214 12.814C16.6214 10.2616 14.5524 8.19238 11.9998 8.19238ZM11.9998 15.814C10.3432 15.8138 8.99997 14.4708 8.99997 12.814C8.99997 11.1572 10.343 9.81398 12 9.81398C13.6568 9.81418 15 11.1572 15 12.814C15 14.4708 13.6568 15.814 11.9998 15.814Z'
        className={clsx(
          className ? 'fill-current' : 'fill-[url(#paint1_linear_2623_2308)]'
        )}
      />
      <path
        d='M17.8844 8.00981C17.8844 8.60621 17.4008 9.08981 16.8044 9.08981C16.2078 9.08981 15.7244 8.60621 15.7244 8.00981C15.7244 7.41321 16.208 6.92981 16.8044 6.92981C17.4008 6.92981 17.8844 7.41341 17.8844 8.00981Z'
        className={clsx(
          className ? 'fill-current' : 'fill-[url(#paint2_linear_2623_2308)]'
        )}
      />
      <defs>
        <linearGradient
          id='paint0_linear_2623_2308'
          x1='4.51056'
          y1='20.3033'
          x2='19.4895'
          y2='5.32446'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFD600' />
          <stop offset='0.5' stopColor='#FF0100' />
          <stop offset='1' stopColor='#D800B9' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_2623_2308'
          x1='8.73193'
          y1='16.082'
          x2='15.2679'
          y2='9.54604'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF6400' />
          <stop offset='0.5' stopColor='#FF0100' />
          <stop offset='1' stopColor='#FD0056' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_2623_2308'
          x1='16.0406'
          y1='8.77353'
          x2='17.568'
          y2='7.24613'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F30072' />
          <stop offset='1' stopColor='#E50097' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const LinkedInIcon: FC<LogoProps> = ({ className, height }) => {
  return (
    <svg
      viewBox='0 0 24 24'
      className={clsx(
        'flex-none',
        height ? height : 'h-6',
        className ?? 'text-[#0A66C2]'
      )}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.00074 5.90654C2.9934 5.62538 3.04391 5.34587 3.1488 5.08708C3.25369 4.8283 3.41049 4.59633 3.60852 4.40701C4.04241 4.00208 4.60919 3.79022 5.18907 3.81621C5.75672 3.78972 6.31154 3.99854 6.734 4.39766C6.93538 4.5978 7.09378 4.84078 7.19859 5.11037C7.3034 5.37996 7.35222 5.66995 7.34179 5.96094C7.34789 6.23355 7.2984 6.50438 7.19664 6.75524C7.09488 7.0061 6.94321 7.2312 6.75181 7.41542C6.3149 7.82791 5.74113 8.04346 5.15427 8.01557H5.13647C4.8539 8.02847 4.57171 7.98203 4.30643 7.87898C4.04115 7.77593 3.79812 7.61833 3.59153 7.41542C3.39809 7.22128 3.24555 6.98669 3.14379 6.72679C3.04203 6.46689 2.9933 6.18745 3.00074 5.90654ZM3.22655 21.8123V9.66982H7.0812V21.8123H3.22655ZM9.2153 21.8123H13.0707V15.0321C13.0569 14.6985 13.1038 14.3653 13.2091 14.0502C13.3685 13.6427 13.6222 13.2833 13.9472 13.0047C14.2998 12.7126 14.7399 12.5619 15.1887 12.5796C16.4835 12.5796 17.131 13.4946 17.131 15.3245V21.814H20.9856V14.8519C21.0866 13.3795 20.6528 11.9215 19.7717 10.7715C19.3637 10.3098 18.8652 9.94641 18.3108 9.70633C17.7563 9.46626 17.1589 9.3552 16.5596 9.38079C15.8596 9.36139 15.1673 9.5381 14.5539 9.89277C13.9405 10.2474 13.428 10.7673 13.0691 11.3989V11.4354H13.0513L13.0691 11.3989V9.66982H9.2169C9.24064 10.0574 9.25224 11.2631 9.2517 13.2869C9.25116 15.3106 9.23956 18.1524 9.2169 21.8123H9.2153Z'
        className='fill-current'
      />
    </svg>
  )
}

export const TwitterIcon: FC<LogoProps> = ({ className, height }) => {
  return (
    <svg
      viewBox='0 0 24 24'
      className={clsx(
        'flex-none',
        height ? height : 'h-6',
        className ?? 'text-[#1D9BF0]'
      )}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 6.91778C20.3377 7.21178 19.626 7.40978 18.879 7.49903C19.6417 7.04228 20.2275 6.31853 20.5027 5.45604C19.7895 5.87903 18.999 6.18653 18.1575 6.35228C17.4847 5.63453 16.524 5.18604 15.462 5.18604C13.0777 5.18604 11.3257 7.41053 11.8642 9.71978C8.796 9.56603 6.075 8.09603 4.25325 5.86178C3.28575 7.52153 3.7515 9.69278 5.3955 10.7923C4.791 10.7728 4.221 10.607 3.72375 10.3303C3.68325 12.041 4.9095 13.6415 6.6855 13.9978C6.16575 14.1388 5.5965 14.1718 5.0175 14.0608C5.487 15.5278 6.8505 16.595 8.4675 16.625C6.915 17.8423 4.959 18.386 3 18.155C4.63425 19.2028 6.576 19.814 8.661 19.814C15.5175 19.814 19.3912 14.0233 19.1572 8.82953C19.8787 8.30828 20.505 7.65803 21 6.91778Z'
        className='fill-current'
      />
    </svg>
  )
}

export const YoutubeIcon: FC<LogoProps> = ({ className, height }) => {
  return (
    <svg
      viewBox='0 0 24 24'
      className={clsx(
        'flex-none',
        height ? height : 'h-6',
        className ?? 'text-[#FF0000]'
      )}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20.6238 8.48152C20.4168 7.70712 19.8068 7.09712 19.0324 6.89012C17.6288 6.51392 12 6.51392 12 6.51392C12 6.51392 6.3712 6.51392 4.9676 6.89012C4.1932 7.09712 3.5832 7.70712 3.3762 8.48152C3 9.88512 3 12.8139 3 12.8139C3 12.8139 3 15.7427 3.3762 17.1463C3.5832 17.9207 4.1932 18.5307 4.9676 18.7377C6.3712 19.1139 12 19.1139 12 19.1139C12 19.1139 17.6288 19.1139 19.0324 18.7377C19.8068 18.5307 20.4168 17.9207 20.6238 17.1463C21 15.7427 21 12.8139 21 12.8139C21 12.8139 21 9.88512 20.6238 8.48152Z'
        className='fill-current'
      />
      <path
        d='M10.2 15.5139L14.876 12.8139L10.2 10.1139V15.5139Z'
        fill='white'
      />
    </svg>
  )
}

export const FaceBookIcon: FC<LogoProps> = ({ className, height }) => {
  return (
    <svg
      viewBox='0 0 24 24'
      className={clsx(
        'flex-none',
        height ? height : 'h-6',
        className ?? 'text-[#1877F2]'
      )}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_3284_4016)'>
        <path
          d='M10.515 20.91C6.24 20.145 3 16.455 3 12C3 7.05 7.05 3 12 3C16.95 3 21 7.05 21 12C21 16.455 17.76 20.145 13.485 20.91L12.99 20.505H11.01L10.515 20.91Z'
          className='fill-current'
        />
        <path
          d='M15.5101 14.5201L15.9151 12.0001H13.5301V10.2451C13.5301 9.52513 13.8001 8.98513 14.8801 8.98513H16.0501V6.69013C15.4201 6.60013 14.7001 6.51013 14.0701 6.51013C12.0001 6.51013 10.5601 7.77013 10.5601 10.0201V12.0001H8.31006V14.5201H10.5601V20.8651C11.0551 20.9551 11.5501 21.0001 12.0451 21.0001C12.5401 21.0001 13.0351 20.9551 13.5301 20.8651V14.5201H15.5101Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_3284_4016'>
          <rect
            width='18'
            height='18'
            fill='white'
            transform='translate(3 3)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const DiscordIcon: FC<LogoProps> = ({ className, height }) => {
  return (
    <svg
      viewBox='0 0 24 24'
      className={clsx(
        'flex-none',
        height ? height : 'h-6',
        className ?? 'text-[#5865F2]'
      )}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18.2477 6.20006C17.0825 5.65491 15.8367 5.25871 14.5342 5.03311C14.3742 5.32232 14.1873 5.71131 14.0585 6.02075C12.6739 5.81252 11.302 5.81252 9.94287 6.02075C9.81404 5.71131 9.62292 5.32232 9.46152 5.03311C8.15761 5.25871 6.91032 5.65636 5.74514 6.20295C3.39498 9.75435 2.75789 13.2175 3.07644 16.6316C4.63519 17.7956 6.14581 18.5027 7.63093 18.9654C7.99762 18.4608 8.32465 17.9243 8.60638 17.3589C8.06981 17.155 7.5559 16.9034 7.07031 16.6113C7.19913 16.5159 7.32514 16.4161 7.44689 16.3134C10.4086 17.6987 13.6267 17.6987 16.5531 16.3134C16.6762 16.4161 16.8022 16.5159 16.9296 16.6113C16.4426 16.9049 15.9273 17.1565 15.3907 17.3604C15.6724 17.9243 15.9981 18.4622 16.3662 18.9669C17.8527 18.5041 19.3647 17.7971 20.9235 16.6316C21.2973 12.6738 20.285 9.24246 18.2477 6.20006ZM9.00988 14.532C8.12079 14.532 7.39166 13.702 7.39166 12.6912C7.39166 11.6804 8.10522 10.849 9.00988 10.849C9.91457 10.849 10.6437 11.679 10.6281 12.6912C10.6295 13.702 9.91457 14.532 9.00988 14.532ZM14.9901 14.532C14.101 14.532 13.3718 13.702 13.3718 12.6912C13.3718 11.6804 14.0854 10.849 14.9901 10.849C15.8947 10.849 16.6238 11.679 16.6083 12.6912C16.6083 13.702 15.8947 14.532 14.9901 14.532Z'
        className='fill-current'
      />
    </svg>
  )
}

export const SlackIcon: FC<LogoProps> = ({ className, height }) => {
  return (
    <svg
      viewBox='0 0 24 24'
      className={clsx('flex-none', height ? height : 'h-6', className)}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.89129 16.266C5.39235 16.2646 5.87248 16.0649 6.22667 15.7105C6.58086 15.356 6.78027 14.8758 6.78129 14.3747V12.4847H4.89129C4.39044 12.4857 3.91037 12.685 3.55598 13.0389C3.20158 13.3928 3.0017 13.8726 3 14.3734C3.00129 15.4161 3.84729 16.2621 4.89 16.2634L4.89129 16.266ZM9.62529 12.4834C9.12422 12.4848 8.64409 12.6845 8.2899 13.039C7.93571 13.3934 7.7363 13.8736 7.73529 14.3747V19.11C7.73786 20.1527 8.58386 20.9974 9.62529 21C10.1261 20.9986 10.6061 20.7991 10.9602 20.4449C11.3144 20.0908 11.5139 19.6108 11.5153 19.11V14.3734C11.5139 13.8726 11.3144 13.3926 10.9602 13.0385C10.6061 12.6843 10.1261 12.4848 9.62529 12.4834Z'
        className={clsx(className ? 'fill-current' : 'fill-[#E01E5A]')}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.73529 4.89129C7.73657 5.934 8.58257 6.78 9.62529 6.78129H11.5153V4.89129C11.5143 4.39044 11.315 3.91037 10.9611 3.55598C10.6072 3.20158 10.1274 3.0017 9.62657 3C9.12573 3.00136 8.64579 3.20092 8.29164 3.55507C7.93749 3.90922 7.73793 4.38916 7.73657 4.89L7.73529 4.89129ZM11.5153 9.62529C11.5139 9.12444 11.3144 8.6445 10.9602 8.29035C10.6061 7.9362 10.1261 7.73664 9.62529 7.73529H4.89C4.38916 7.73664 3.90922 7.9362 3.55507 8.29035C3.20092 8.6445 3.00136 9.12444 3 9.62529C3.00257 10.6693 3.84857 11.514 4.89 11.5153H9.62657C10.1274 11.5139 10.6074 11.3144 10.9615 10.9602C11.3157 10.6061 11.5139 10.1261 11.5153 9.62529Z'
        className={clsx(className ? 'fill-current' : 'fill-[#36C5F0]')}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.3748 11.5166C14.8756 11.5152 15.3556 11.3157 15.7097 10.9615C16.0639 10.6074 16.2634 10.1274 16.2648 9.62657V4.89C16.2634 4.38938 16.0641 3.90963 15.7102 3.55552C15.3563 3.20141 14.8767 3.0017 14.3761 3C13.8752 3.00136 13.3953 3.20092 13.0412 3.55507C12.687 3.90922 12.4874 4.38916 12.4861 4.89V9.62657C12.4887 10.668 13.3321 11.514 14.3748 11.5166ZM19.1088 7.73529C18.608 7.73664 18.128 7.9362 17.7739 8.29035C17.4197 8.6445 17.2202 9.12444 17.2188 9.62529V11.5153H19.1088C19.6096 11.5143 20.0897 11.315 20.4441 10.9611C20.7985 10.6072 20.9984 10.1274 21.0001 9.62657C20.9987 9.12573 20.7992 8.64579 20.445 8.29164C20.0909 7.93749 19.6109 7.73793 19.1101 7.73657L19.1088 7.73529Z'
        className={clsx(className ? 'fill-current' : 'fill-[#2EB67D]')}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.4846 14.3747C12.4872 15.4174 13.3319 16.2634 14.3746 16.2647H19.1099C19.6105 16.2634 20.0903 16.064 20.4444 15.7101C20.7985 15.3562 20.9982 14.8766 20.9999 14.376C20.9985 13.8751 20.799 13.3952 20.4448 13.0411C20.0907 12.6869 19.6107 12.4873 19.1099 12.486H14.3746C13.8738 12.4873 13.3938 12.6869 13.0397 13.0411C12.6855 13.3952 12.486 13.8739 12.4846 14.3747ZM16.2646 19.1087C16.2633 18.6079 16.0637 18.1279 15.7096 17.7738C15.3554 17.4196 14.8755 17.2201 14.3746 17.2187H12.4846V19.1087C12.4872 20.1527 13.3319 20.9974 14.3746 20.9987C14.8755 20.9973 15.3554 20.7978 15.7096 20.4436C16.0637 20.0895 16.2633 19.6095 16.2646 19.1087Z'
        className={clsx(className ? 'fill-current' : 'fill-[#ECB22E]')}
      />
    </svg>
  )
}
